import React from 'react';
import AppRoutes from './routes';
import { ToastContainer } from 'react-toastify';
import Loader from './components/Loader/Loader';
import './App.css'

const App = () => {
  return (
    <div>
      <AppRoutes />
      <ToastContainer />
      <Loader />
    </div>
  );
};

export default App;